import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Recommendations() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState<string | null>(null);

  const refresh = () => {
    setLoading(true);
    api.recommendations().then(setRows).finally(() => setLoading(false));
  };
  useEffect(refresh, []);

  async function accept(id: string) {
    await api.acceptRec(id);
    setToast('Applied');
    setTimeout(() => setToast(null), 1800);
    refresh();
  }
  async function dismiss(id: string) {
    await api.dismissRec(id);
    refresh();
  }
  async function runNow() {
    await api.runOptimiser();
    refresh();
  }

  return (
    <>
      <h2 className="page-title">Recommendations</h2>
      <p className="page-sub">AI suggestions from the optimiser. Accept to apply automatically; dismiss to hide.</p>

      <div style={{ marginBottom: 16 }}>
        <button className="btn btn-small" onClick={runNow}>
          ↻ Re-run optimiser
        </button>
      </div>

      {loading ? (
        <div className="empty">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="empty">🎉 All clear. Nothing needs your attention right now.</div>
      ) : (
        rows.map((r) => {
          const payload = JSON.parse(r.payload_json);
          return (
            <div key={r.id} className={`rec-card ${r.kind}`}>
              <h4>{r.title}</h4>
              <p>{r.rationale}</p>
              {r.expected_impact && <div className="impact">{r.expected_impact}</div>}
              <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                <span className={`badge badge-${payload.platform ?? 'meta'}`}>{payload.platform ?? 'multi'}</span>
                <span className={`badge badge-${r.kind === 'scale' ? 'active' : 'paused'}`}>{r.kind}</span>
                <span className="badge badge-draft">score {r.score.toFixed(2)}</span>
              </div>
              <div className="row" style={{ marginTop: 12 }}>
                <button className="btn btn-primary btn-small" onClick={() => accept(r.id)}>
                  Accept
                </button>
                <button className="btn btn-small" onClick={() => dismiss(r.id)}>
                  Dismiss
                </button>
              </div>
            </div>
          );
        })
      )}

      {toast && <div className="toast">{toast}</div>}
    </>
  );
}
